export namespace InstrumentoAction {

  export class FetchFavoritos {

    static readonly type = '[InstrumentoAction] Fetch instrumentos';
    constructor(public ids: number[]) {}
  }

  export class FetchFavorites {

    static readonly type = '[InstrumentoAction] Fetch favorites';
    constructor(public ids: number[]) {}
  }

  export class FetchTiposInstrumento {

    static readonly type = '[InstrumentoAction] Fetch tipo de instrumentos';
    constructor() {}
  }

  export class FetchSectores {

    static readonly type = '[InstrumentoAction] Fetch sectores';
    constructor() {}
  }

}
